import { baseQuerySetup,onQueryStarted, onCacheEntryAdded } from 'config/index';
import { createApi } from '@reduxjs/toolkit/query/react';
import { MARKETPLACE_PREFIX } from 'constants/index';
import { getResponsedata } from 'config';
let transactionReducer = 'TransactionReducer';
let transactionTag = 'transactionTag';

export const transactionApi = createApi({
    reducerPath: transactionReducer,
    baseQuery: baseQuerySetup,
    tagTypes: [transactionTag],
    endpoints: (builder) => ({
        getAllTransaction: builder.query({
            query: ({ query }) => {
                // const query = new URLSearchParams(params).toString();
                return { url: MARKETPLACE_PREFIX + '/applications' + query, method: 'GET' };
                // the search query params
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: getResponsedata,
            providesTags: [transactionTag]
        }),
        getTransactionById: builder.query({
            query: (id) => {
                // const query = new URLSearchParams(params).toString();
                return { url: MARKETPLACE_PREFIX + '/applications/' + id, method: 'GET' };
                // the search query params
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: getResponsedata,
            providesTags: [transactionTag]
        })
    })
});

export const { useGetAllTransactionQuery, useGetTransactionByIdQuery } = transactionApi;
